import Customer from "models/Customer";

export const SET_SETTING = "customerAdminSetting/SET_SETTING";
export const CHANGE_LOGO = "customerAdminSetting/CHANGE_LOGO";
export const SET_ERRORS = "customerAdminSetting/SET_ERRORS";

export const setSetting = res => ({
  type: SET_SETTING,
  customer: new Customer(res.customer)
});

export const changeLogo = logo => ({
  type: CHANGE_LOGO,
  logo
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  customer: new Customer(),
  errors: []
};

const customerAdminSetting = (state = initialState, action) => {
  switch (action.type) {
    case SET_SETTING: {
      return { ...state, customer: action.customer };
    }
    case CHANGE_LOGO: {
      const customer = state.customer.set("logo", action.logo);

      return { ...state, customer };
    }

    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    default:
      return state;
  }
};

export default customerAdminSetting;



// WEBPACK FOOTER //
// ./src/redux/modules/customerAdminSetting.js